import type { CentrifugeMessage } from '../messageTypes';

export interface MuteOnMessage {
  data: {
    type: 'MuteOn';
    message: {
      type: string;
      type_en: string;
      type_ja: string;
      name: string;
      idx: number;
      id: string;
      muteTime: number;
    };
    created_at?: number;
  };
  offset: number;
}

export interface MuteOffMessage {
  data: {
    type: 'MuteOff';
    message: { type: string; type_en: string; type_ja: string; name: string; idx: number; id: string };
    created_at?: number;
  };
  offset: number;
}

export interface CustomMuteOnMessage {
  data: {
    type: 'CustomMuteOn';
    message: {
      idx: number;
      muteTime: number;
    };
    created_at?: number;
  };
  offset: number;
}

export const isMuteOnMessage = (item: CentrifugeMessage): item is MuteOnMessage => {
  return 'data' in item && item.data.type === 'MuteOn';
};

export const isMuteOffMessage = (item: CentrifugeMessage): item is MuteOffMessage => {
  return 'data' in item && item.data.type === 'MuteOff';
};

export const isCustomMuteOnMessage = (item: CentrifugeMessage): item is CustomMuteOnMessage => {
  return 'data' in item && item.data.type === 'CustomMuteOn';
};
